module.exports = __webpack_public_path__ + "img/twcnvweb.b69d0f90.png";